/** @format */

import React, { forwardRef, useImperativeHandle, useMemo } from "react";
import { useParams } from "react-router-dom";
import { Card } from "primereact/card";
import { Chart } from "primereact/chart";
import { ScrollPanel } from "primereact/scrollpanel";
import { SURVEY } from "./constants/constants";
import ThreeDotsLoader from "../common/ThreeDotsLoader";
import useGetSummarySurveyReport from "./hooks/useGetSurveySummaryReport";

const SurveySummary = forwardRef((props, ref) => {
  const params = useParams();
  const { data, isLoading } = useGetSummarySurveyReport(
    params.id,
    params.id !== "" || params.id !== null || params.id !== undefined,
    props.status
  );

  const CHART_BG_COLORS = useMemo(() => ["#BC080D", "#CF7F00", "#EBD073", "#005F86", "#658D1B"], []);
  const lightOptions = useMemo(
    () => ({
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: {
          position: "left",
          align: "end",
          labels: {
            fontColor: "#FFF",
            usePointStyle: true,
          },
        },
      },
    }),
    []
  );
  useImperativeHandle(ref, () => {
    return {
      reportType: SURVEY.TYPE.SUMMARY,
      getCurrentUserData: () => data,
    };
  }, [data]);
  const isSummaryQuestionEmpty = useMemo(() => {
    return (
      data === null ||
      data === undefined ||
      data.surveyQuestions === null ||
      data.surveyQuestions === undefined ||
      (Array.isArray(data.surveyQuestions) && data.surveyQuestions.length === 0)
    );
  }, [data]);
  const isShortAnswerEmpty = useMemo(() => {
    return (
      data === null ||
      data === undefined ||
      data.shortAnswerQuestionDTOS === null ||
      data.shortAnswerQuestionDTOS === undefined ||
      (Array.isArray(data.shortAnswerQuestionDTOS) && data.shortAnswerQuestionDTOS.length === 0)
    );
  }, [data]);

  const isSummaryEmpty = isSummaryQuestionEmpty && isShortAnswerEmpty;
  return (
    <div className='survey__report__consolidated mt-2' ref={ref}>
      {isLoading ? (
        <div className='wtg__loader'>
          <ThreeDotsLoader />
        </div>
      ) : null}
      {isSummaryEmpty ? (
        <p className='p-text-center'>No Responses</p>
      ) : (
        <>
          {isSummaryQuestionEmpty ? null : (
            <div className='grid  py-5 px-6'>
              <div className='col-12'>
                <h3>Customer Feedback</h3>
              </div>
              {data.surveyQuestions.map((question, index) => {
                const chartData = {
                  labels: question.optionRequestDTOS.map((option) => option.option),
                  datasets: [
                    {
                      data: question.optionRequestDTOS.map((option) => option.percentage),
                      backgroundColor: CHART_BG_COLORS.slice(0, question.optionRequestDTOS.length),
                    },
                  ],
                };
                return (
                  <div className='col-6' key={question}>
                    <div className='p-4 survey__report__chart__container'>
                      <p>
                        {index + 1}. {question.name}?
                      </p>
                      {/* <p>(50 Responses)</p> */}
                      <Chart className='mt-5' type='pie' data={chartData} options={lightOptions} />
                    </div>
                  </div>
                );
              })}
            </div>
          )}
          {isShortAnswerEmpty ? null : (
            <div className='grid  py-5 px-6 mt-6'>
              {data.shortAnswerQuestionDTOS.map((shortAnswer, index, shortAnswers) => {
                return (
                  <div className='col-12 print-pb-2' key={`${shortAnswer}-${index}`}>
                    <p>
                      {data.surveyQuestions.length + index + 1}. {shortAnswer.question}?
                    </p>
                    <p>
                      ({shortAnswer.answers.length} {shortAnswer.answers.length === 1 ? "Response" : "Responses"})
                    </p>
                    <ScrollPanel style={{ height: "250px" }}>
                      {shortAnswer.answers.map((val, ind) => (
                        <Card key={`${val}-${ind}`}>{val}</Card>
                      ))}
                    </ScrollPanel>
                  </div>
                );
              })}
            </div>
          )}
        </>
      )}
    </div>
  );
});

export default SurveySummary;
